__turbopack_context__.v({
  "column": "company-manifesto-module__STLfvW__column",
  "container": "company-manifesto-module__STLfvW__container",
  "content": "company-manifesto-module__STLfvW__content",
  "grid": "company-manifesto-module__STLfvW__grid",
  "header": "company-manifesto-module__STLfvW__header",
  "item": "company-manifesto-module__STLfvW__item",
  "itemText": "company-manifesto-module__STLfvW__itemText",
  "section": "company-manifesto-module__STLfvW__section",
});
